// Import model
import { StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest } from '../models/StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest instance
   */
  static deserialize(json: string): StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest instance
   */
  static fromObject(obj: any): StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest');
    }


    const instance: StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest = {
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest instances
   */
  static deserializeArray(json: string): StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest instance to a plain object
   */
  static toObject(instance: StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest): any {
    return {
      'UnlayerTemplateId': instance.unlayerTemplateId,
    };
  }

  /**
   * Serializes an array of StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAppointmentSendCustomAppointmentConfirmationEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
